export default "__VITE_ASSET__BgRI_maY__"